import Areas from '../support/Areas.js';
import PrivateRoute from "../auth/PrivateRoute.js";
import PageList from "../pages/PageList.js";
import Page from "../pages/Page.js";
import useAuth from "../auth/useAuth.js";

import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Route, Switch, useRouteMatch } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';

const EditPage = lazy(() => import('./EditPage.js'));

const Pages = () => {
    const auth = useAuth();
    const [isAdmin, setIsAdmin] = useState(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("admin") !== -1);
    const [canView, setCanView] = useState(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("admin") !== -1);
    const [search, setSearch] = useState(Areas.find(x => x.url === 'search'));
    
    useEffect(() => {
        setIsAdmin(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("admin") !== -1);
    }, [auth]);

    const hasAccess = (area) => {
        return area.features.indexOf("publicList") !== -1 ||
            (auth.user.id && auth.user?.roles && area.roles.some(r => auth.user.roles.indexOf(r) !== -1));
    }

    return (
        <Switch>
            {Areas.map((value, index) => {
                return (
                    <Route exact key={"list-" + value.url} path={'/' + value.url}>
                        {hasAccess(value) ? <PageList area={value} /> : <PageList area={search} />}
                    </Route>
                );
            })}
            {Areas.map((value, index) => {
                return (
                    <Route key={"page-" + value.url} path={'/' + value.url + '/:id'}>
                    <PageManager area={value} />
                 </Route>
                );
            })}
        </Switch>
    );
};


//this can only be run through router. pages themselves need to be rendered independently of the router
const PageManager = (props) => {
    const [Area, setArea] = useState(props?.area);
    let match = useRouteMatch();
    return (
        <Switch>
            <Route exact path={match.path}>
                <Page id={match.params.id} area={Area} />
            </Route>

            <PrivateRoute path={match.path + '/edit'} roles={Area.roles}>
                <Suspense fallback={<CircularProgress />}><EditPage id={match.params.id} area={Area} /></Suspense>
            </PrivateRoute>
        </Switch>
    );
};

export default Pages;
